import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { sendApplicationDocumentRequest } from '../service'

export const useSendApplicationDocumentRequest: WriteHook<{ id: number }, void> = (opts) =>
  useMutationManager(sendApplicationDocumentRequest, opts)
